import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { authService } from '../../services/auth.service';
import { AuthLoading } from './AuthSplitLayout';

interface MustChangePasswordGuardProps {
  children: React.ReactNode;
}

export const MustChangePasswordGuard: React.FC<MustChangePasswordGuardProps> = ({ children }) => {
  const [isChecking, setIsChecking] = useState(true);
  const [mustChangePassword, setMustChangePassword] = useState(false);

  useEffect(() => {
    const checkPasswordStatus = async () => {
      try {
        const response = await authService.validateToken();
        console.log('MustChangePasswordGuard - validateToken response:', response);
        if (response && response.user?.mustChangePassword) {
          console.log('MustChangePasswordGuard - mustChangePassword is true, redirecting');
          setMustChangePassword(true);
        }
      } catch (error) {
        console.error('Error checking password status:', error);
      } finally {
        setIsChecking(false);
      }
    };

    checkPasswordStatus();
  }, []);

  if (isChecking) {
    return <AuthLoading />;
  }

  if (mustChangePassword) {
    return <Navigate to="/change-password" replace />;
  }

  return <>{children}</>;
};